import { FormattedMessage } from 'react-intl';
import { StyledCard } from '../../../../../../../components/StyledCard';
import { DownloadBtns } from './DownloadBtns';

export function FragmentMediaFiles() {
  return (
    <StyledCard
      size="sm"
      sx={{ maxWidth: 'md' }}
      title={
        <FormattedMessage id="fragments.mediaStatus.title" defaultMessage="Archivos de media" />
      }
    >
      <DownloadBtns />
    </StyledCard>
  );
}
